import React from 'react';
// @ts-ignore
import { Annotation } from '@jd/jmtd';

export const REALTIME_TARGETS = [
  {
    label: '基础属性',
    data: [
      {
        label: '店铺',
        value: 'shop_name'
      },
      {
        label: '品类',
        value: 'item_cate_name_1'
      },
      {
        label: '品牌',
        value: 'brand_name'
      }
    ]
  },
  {
    label: '交易指标',
    data: [
      {
        label: (<>成交金额<Annotation>在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。</Annotation></>),
        value: 'ge_deal_standard_deal_ord_amt',
        tip: '	在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
        disabled: true,
        decimal: 0
      },
      {
        label: (<>成交子单量<Annotation>大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。\n' +
          '末次来源口径：所选维度下，权限对应商品/店铺成交订单的子单量</Annotation></>),
        value: 'ge_deal_standard_deal_sub_ord_qtty',
        tip: '大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。\n' +
          '末次来源口径：所选维度下，权限对应商品/店铺成交订单的子单量。',
        decimal: 0,
        sorter: true,
      },

      {
        label: (<>成交数量<Annotation>大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。</Annotation></>),
        value: 'ge_deal_standard_deal_item_qtty',
        tip: '大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。',
        decimal: 0
      },
      {
        label: (<>成交客单价<Annotation>大盘口径：成交金额/成交子单量\n' +
          '末次来源口径：流量来源去向成交金额/流量来源去向成交用户数。</Annotation></>),
        value: 'fo_ge_deal_app_atv',
        tip: '大盘口径：成交金额/成交子单量\n' +
          '末次来源口径：流量来源去向成交金额/流量来源去向成交用户数。'
      },
      {
        label: (<>成交件单价<Annotation>大盘口径：成交金额/成交商品数量</Annotation></>),
        value: 'fo_ge_deal_app_item_value',
        tip: '大盘口径：成交金额/成交商品数量'
      },
      {
        label: (<>成交转化率<Annotation>大盘口径：成交购买用户/商详UV\n' +
          '末次来源口径：流量来源去向成交客户数/流量来源去向商详访客数（UV）。</Annotation></>),
        value: 'fo_flow_item_detail_view_uv_user_per',
        tip: '大盘口径：成交购买用户/商详UV\n' +
          '末次来源口径：流量来源去向成交客户数/流量来源去向商详访客数（UV）。',
        format: '%'
      },
      {
        label: (<>出库金额<Annotation>大盘口径：出库金额实物以订单出库时间统计，虚拟以对账时间统计，统计周期内，出库订单包含的商品总金额。金额 = 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销）促销优惠金额 – 所有优惠券金额+全球购税费+运费+服务费。</Annotation></>),
        value: 'ge_deal_standard_out_ord_amt',
        tip: '大盘口径：出库金额实物以订单出库时间统计，虚拟以对账时间统计，统计周期内，出库订单包含的商品总金额。金额 = 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销）促销优惠金额 – 所有优惠券金额+全球购税费+运费+服务费。',
        decimal: 0
      },
      {
        label: (<>出库件数<Annotation>大盘口径：出库数量实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。</Annotation></>),
        value: 'ge_deal_standard_out_ord_item_qtty',
        tip: '大盘口径：出库数量实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
        decimal: 0
      },
      {
        label: (<>出库子单量<Annotation>大盘口径：出库子单实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。</Annotation></>),
        value: 'ge_deal_standard_out_sub_ord_qtty',
        tip: '大盘口径：出库子单实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
        decimal: 0
      }
    ]
  },
  {
    label: '流量指标',
    data: [
      {
        label: (<>商详UV<Annotation>大盘口径：统计周期内，访问过商品详情页面的独立访客数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量的访客数。</Annotation></>),
        value: 'flow_item_detail_view_uv',
        tip: '大盘口径：统计周期内，访问过商品详情页面的独立访客数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量的访客数。',
        decimal: 0,
        sorter: true,
      },
      {
        label: (<>商详PV<Annotation>大盘口径：统计周期内，商品详情页面被访问的次数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量。</Annotation></>),
        value: 'flow_item_detail_view_pv',
        tip: '大盘口径：统计周期内，商品详情页面被访问的次数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量。',
        decimal: 0
      },
      {
        label: (<>加购转化率<Annotation>末次来源口径：流量来源去向加购客户数/流量来源去向商详访客数（UV）</Annotation></>),
        value: 'fo_flow_source_to_item_cart_user_cvr',
        tip: '末次来源口径：流量来源去向加购客户数/流量来源去向商详访客数（UV）',
        format: '%'
      },
    ]
  },
  {
    label: '用户指标',
    data: [
      {
        label: (<>成交购买用户<Annotation>大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交支付（货到下单）且未取消订单的用户数，跨天为按日累加。与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，且对用户数进行了归一，商智不剔除。\n' +
          '末次来源口径：对应来源去向下商品的成交客户数。</Annotation></>),
        value: 'deal_buy_user_qtty',
        tip: '大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交支付（货到下单）且未取消订单的用户数，跨天为按日累加。与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，且对用户数进行了归一，商智不剔除。\n' +
          '末次来源口径：对应来源去向下商品的成交客户数。',
        decimal: 0
      },
      {
        label: (<>站外新-有效<Annotation>大盘口径：全平台第一次成功提交且未取消订单的用户数（有效口径）。</Annotation></>),
        value: 'fir_time_buy_user_qtty',
        tip: '大盘口径：全平台第一次成功提交且未取消订单的用户数（有效口径）。',
        decimal: 0,
        spu_hidden: true
      },
      {
        label: (<>老用户-有效<Annotation>大盘口径：购买两次及以上的用户数，即有效购买用户-首购用户</Annotation></>),
        value: 'fo_old_time_buy_user_qtty',
        tip:
          '大盘口径：购买两次及以上的用户数，即有效购买用户-首购用户',
        spu_hidden: true,
        decimal: 0
      },
      {
        label: (<>有效购买用户<Annotation>以订单下单时间统计，统计周期内，成功提交且未取消订单的用户数，剔除十万以上未支付订单、内采等，跨天为按日累加。</Annotation></>),
        value: 'eff_buy_user_qtty',
        tip: '以订单下单时间统计，统计周期内，成功提交且未取消订单的用户数，剔除十万以上未支付订单、内采等，跨天为按日累加。',
        decimal: 0
      }
    ]
  },
];

export const OFFLINE_TARGETS = [
  {
    label: '基础属性',
    data: [
      {
        label: '店铺',
        value: 'shop_name'
      },
      {
        label: '品类',
        value: 'item_cate_name_1'
      },
      {
        label: '品牌',
        value: 'brand_name'
      }
    ]
  },
  {
    label: '交易指标',
    data: [
      {
        label: (<>成交金额<Annotation>	在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。</Annotation></>),
        value: 'ge_deal_standard_deal_ord_amt',
        tip: '	在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
        disabled: true,
        decimal: 0
      },
      {
        label: (<>成交子单量<Annotation>大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。\n' +
          '末次来源口径：所选维度下，权限对应商品/店铺成交订单的子单量。</Annotation></>),
        value: 'ge_deal_standard_deal_sub_ord_qtty',
        tip: '大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。\n' +
          '末次来源口径：所选维度下，权限对应商品/店铺成交订单的子单量。',
        decimal: 0,
        sorter: true,
      },

      {
        label: (<>成交数量<Annotation>大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。</Annotation></>),
        value: 'ge_deal_standard_deal_item_qtty',
        tip: '大盘口径：在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：黄金眼剔除非金融内采和礼品卡类目订单，商智不剔除。',
        decimal: 0
      },
      {
        label: (<>成交客单价<Annotation>大盘口径：成交金额/成交子单量\n' +
          '末次来源口径：流量来源去向成交金额/流量来源去向成交用户数。</Annotation></>),
        value: 'fo_ge_deal_app_atv',
        tip: '大盘口径：成交金额/成交子单量\n' +
          '末次来源口径：流量来源去向成交金额/流量来源去向成交用户数。'
      },
      {
        label: (<>成交件单价<Annotation>大盘口径：成交金额/成交商品数量</Annotation></>),
        value: 'fo_ge_deal_app_item_value',
        tip: '大盘口径：成交金额/成交商品数量'
      },
      {
        label: (<>成交转化率<Annotation>大盘口径：成交购买用户/商详UV\n' +
          '末次来源口径：流量来源去向成交客户数/流量来源去向商详访客数（UV）。</Annotation></>),
        value: 'fo_flow_item_detail_view_uv_user_per',
        tip: '大盘口径：成交购买用户/商详UV\n' +
          '末次来源口径：流量来源去向成交客户数/流量来源去向商详访客数（UV）。',
        format: '%'
      },
      {
        label: (<>出库金额<Annotation>大盘口径：出库金额实物以订单出库时间统计，虚拟以对账时间统计，统计周期内，出库订单包含的商品总金额。金额 = 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销）促销优惠金额 – 所有优惠券金额+全球购税费+运费+服务费。</Annotation></>),
        value: 'ge_deal_standard_out_ord_amt',
        tip: '大盘口径：出库金额实物以订单出库时间统计，虚拟以对账时间统计，统计周期内，出库订单包含的商品总金额。金额 = 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销）促销优惠金额 – 所有优惠券金额+全球购税费+运费+服务费。',
        decimal: 0
      },
      {
        label: (<>出库件数<Annotation>大盘口径：出库数量实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。</Annotation></>),
        value: 'ge_deal_standard_out_ord_item_qtty',
        tip: '大盘口径：出库数量实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
        decimal: 0
      },
      {
        label: (<>出库子单量<Annotation>大盘口径：出库子单实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。</Annotation></>),
        value: 'ge_deal_standard_out_sub_ord_qtty',
        tip: '大盘口径：出库子单实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
        decimal: 0
      }
    ]
  },
  {
    label: '流量指标',
    data: [
      {
        label: (<>商详UV<Annotation>大盘口径：统计周期内，访问过商品详情页面的独立访客数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量的访客数。</Annotation></>),
        value: 'flow_item_detail_view_uv',
        tip: '大盘口径：统计周期内，访问过商品详情页面的独立访客数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量的访客数。',
        decimal: 0,
        sorter: true,
      },
      {
        label: (<>商详PV<Annotation>大盘口径：统计周期内，商品详情页面被访问的次数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量。</Annotation></>),
        value: 'flow_item_detail_view_pv',
        tip: '大盘口径：统计周期内，商品详情页面被访问的次数。\n' +
          '末次来源口径：对应来源去向下商品详情页产生的流量。',
        decimal: 0
      },
      {
        label: (<>加购转化率<Annotation>末次来源口径：流量来源去向加购客户数/流量来源去向商详访客数（UV）</Annotation></>),
        value: 'fo_flow_source_to_item_cart_user_cvr',
        tip: '末次来源口径：流量来源去向加购客户数/流量来源去向商详访客数（UV）',
        format: '%'
      },
    ]
  },
  {
    label: '用户指标',
    data: [
      {
        label: (<>成交购买用户<Annotation>在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交支付（货到下单）且未取消订单的用户数，跨天为按日累加。</Annotation></>),
        value: 'deal_buy_user_qtty',
        tip: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交支付（货到下单）且未取消订单的用户数，跨天为按日累加。',
        decimal: 0
      },
      {
        label: (<>站外新-有效<Annotation>大盘口径：全平台第一次成功提交且未取消订单的用户数（有效口径）。</Annotation></>),
        value: 'fir_time_buy_user_qtty',
        tip: '大盘口径：全平台第一次成功提交且未取消订单的用户数（有效口径）。',
        decimal: 0,
        spu_hidden: true
      },
      {
        label: (<>老用户-有效<Annotation>大盘口径：购买两次及以上的用户数，即有效购买用户-首购用户</Annotation></>),
        value: 'fo_old_time_buy_user_qtty',
        decimal: 0,
        tip:
          '大盘口径：购买两次及以上的用户数，即有效购买用户-首购用户',
        spu_hidden: true
      },
      {
        label: (<>有效购买用户<Annotation>以订单下单时间统计，统计周期内，成功提交且未取消订单的用户数，剔除十万以上未支付订单、内采等，跨天为按日累加。</Annotation></>),
        value: 'eff_buy_user_qtty',
        tip: '以订单下单时间统计，统计周期内，成功提交且未取消订单的用户数，剔除十万以上未支付订单、内采等，跨天为按日累加。',
        decimal: 0
      }
    ]
  },
  {
    label: '排名指标',
    autoCollapse: true,
    data: [
      {
        label: (<>全国7日一级点击band<Annotation>全国7日一级点击band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_first_cate_click_band_qtty',
        tip:
          '全国7日一级点击band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日三级点击band<Annotation>全国7日三级点击band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_third_cate_click_band_qtty',
        tip:
          '全国7日三级点击band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日一级点击band<Annotation>全国28日一级点击band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_first_cate_click_band_qtty',
        tip:
          '全国28日一级点击band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日三级点击band<Annotation>全国28日三级点击band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_third_cate_click_band_qtty',
        tip:
          '全国28日三级点击band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日一级销量band<Annotation>全国7日一级销量band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_first_cate_deal_band_qtty',
        tip:
          '全国7日一级销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日三级销量band<Annotation>全国7日三级销量band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_third_cate_deal_band_qtty',
        tip:
          '全国7日三级销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日一级销量band<Annotation>全国28日一级销量band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_first_cate_deal_band_qtty',
        tip:
          '全国28日一级销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日三级销量band<Annotation>全国28日三级销量band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_third_cate_deal_band_qtty',
        tip:
          '全国28日三级销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日一级销售额band<Annotation>全国7日一级销售额band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_first_cate_deal_band_amt',
        tip:
          '全国7日一级销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日三级销售额band<Annotation>全国7日三级销售额band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_third_cate_deal_band_amt',
        tip:
          '全国7日三级销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日一级销售额band<Annotation>全国28日一级销售额band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_first_cate_deal_band_amt',
        tip:
          '全国28日一级销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日三级销售额band<Annotation>全国28日三级销售额band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_third_cate_deal_band_amt',
        tip:
          '全国28日三级销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日一级品牌销量band<Annotation>全国7日一级品牌销量band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_first_cate_brand_deal_band_qtty',
        tip:
          '全国7日一级品牌销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日三级品牌销量band<Annotation>全国7日三级品牌销量band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_third_cate_brand_deal_band_qtty',
        tip:
          '全国7日三级品牌销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日一级品牌销量band<Annotation>全国28日一级品牌销量band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_first_cate_brand_deal_band_qtty',
        tip:
          '全国28日一级品牌销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日三级品牌销量band<Annotation>全国28日三级品牌销量band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_third_cate_brand_deal_band_qtty',
        tip:
          '全国28日三级品牌销量band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日一级品牌销售额band<Annotation>全国7日一级品牌销售额band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_first_brand_deal_band_amt',
        tip:
          '全国7日一级品牌销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国7日三级品牌销售额band<Annotation>全国7日三级品牌销售额band</Annotation></>),
        value: 'supply_chain_standard_last_7_days_item_third_brand_deal_band_amt',
        tip:
          '全国7日三级品牌销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日一级品牌销售额band<Annotation>全国28日一级品牌销售额band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_first_brand_deal_band_amt',
        tip:
          '全国28日一级品牌销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      },
      {
        label: (<>全国28日三级品牌销售额band<Annotation>全国28日三级品牌销售额band</Annotation></>),
        value: 'supply_chain_standard_last_28_days_item_third_brand_deal_band_amt',
        tip:
          '全国28日三级品牌销售额band',
        spu_hidden: true,
        no_ratio: true,
        offline_hidden: true,
      }
    ]
  },
  {
    label: '服务指标',
    autoCollapse: true,
    data: [
      {
        label: '免费上门取退（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_free_return_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持7天无理由退货（使用后不支持）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_use',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持7天无理由退货（定制类不支持）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_custom',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '安联15天价保险（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_price_insurance_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '安联30天价保险（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_price_insurance_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '破损包退换（自营）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_damaged_return_self',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '新品（加权）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_isfzxp_weight',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持7天无理由退货（拆封后不支持）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_unpack',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持7天无理由退货（安装后不支持）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_install',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持30天无理由退货',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_return',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '新品（普通）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_isfzxp_regular',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '30天价保（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_price_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '48小时发货（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_48_hour_delivery_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '晚必赔（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_late_must_pay_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '破损包退换（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_damaged_return_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '放心购',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_buy_ease',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持7天无理由退货',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '不支持7天无理由退货',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_unsupport',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '极速审核（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_audit_speed_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '省心装',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_install_easy',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '趋势好物',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_good_trend',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '24H发货（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_24_hour_delivery_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '上门换新（自营）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_replace_onsite_self',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '支持15天无理由退货',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_return',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '科技运费险（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_tech_freight_insure_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '7天价保（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_price_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '电器延保险（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_extend_insure_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '一年质保（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_one_year_quality_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '90天价保（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_90_price_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '闪电退款（自营）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_refund_speed_self',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '上门取件（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_pickup_onsite_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '15天价保（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_price_pop',
        no_ratio: true,
        show_text:true,
      },
      {
        label: '闪电退款（POP）',
        value: 'jdr_sch_on_shelves_sku_value_ser_surp_tag_refund_speed_pop',
        no_ratio: true,
        show_text:true,
      },
    ]
  }
];

export const ALL_TARGET_MAP: { [key: string]: any } = {};
REALTIME_TARGETS.map((ele) => {
  ele.data.map((item: any) => {
    ALL_TARGET_MAP[item.value] = item;
  });
});
OFFLINE_TARGETS.map((ele) => {
  ele.data.map((item: any) => {
    ALL_TARGET_MAP[item.value] = item;
  });
});
